import {useContext} from 'react';
import {useParams, useRouteMatch} from 'react-router-dom';
import {InviteSenderType} from '../../../../../../../backend/enums/invite-sender-type';
import {InformalCaregiverInviteForm} from '../../../../../../../components/informal-caregiver-invite-form/informal-caregiver-invite-form';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {Card, Box} from '@mui/material';
import {translations} from '../../../../../../../i18n/translations';
import GenericHeader from '../../../../../../../components/generic-header/generic-header';
import {useTranslation} from 'react-i18next';
import {ScreenPaths} from '../../../../../../../enums';

export default function SeniorInviteInformalCaregiverProfessionalCaregiverOfficeScreen() {
  let {id, entityId}: {id?: string; entityId?: string} = useParams();
  const officeContext: OfficeContextType = useContext(OfficeContext);
  let {url} = useRouteMatch();
  const {t} = useTranslation();
  const seniorName =
    officeContext.state.userForm?.user.displayName || officeContext.state.userForm?.user.name;

  return (
    <Box className="senior-caregiver-invite-wrapper">
      <GenericHeader
        titleCrumbs={[
          {
            label: t(translations.screen_paths.professional_caregiver_seniors),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
          },
          {
            label: seniorName,
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
          },
          {
            label: t(translations.screen_paths.senior_personal_data),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}`,
          },
          {
            label: t(translations.screen_paths.senior_caregivers),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Caregivers}`,
          },
          {
            label: t(translations.informal_caregiver_invite_form.title),
            link: url,
          },
        ]}
        isLoading={false}
        leftColumn={null}
      />
      <Card className="senior-profile-card" elevation={0}>
        <InformalCaregiverInviteForm
          seniorId={id || ''}
          seniorName={officeContext.state.userForm?.user.name || ''}
          senderType={InviteSenderType.Entity}
          senderId={entityId || ''}
          redirectUrl={url.replace('/invite', '/invites')}
        />
      </Card>
    </Box>
  );
}
